import React, { useState, useEffect } from 'react';
import { track, Events } from '../../analytics';
import FixEmptyBacktestModal from '../../components/FixEmptyBacktestModal';
import Button from '../../components/Button';

// Banner shown when a backtest completes but the strategy never traded
// (total_trades === 0). A blank, flat result feels identical to a failure, so
// instead of a dead end we offer a modal with two ways to get it trading:
// AI suggestions, or jumping straight into Quick Edit.
export default function EmptyTradesCTA({ backtest, onEditInQuickEdit, onRetested, onRequiresSignup }) {
  const [showModal, setShowModal] = useState(false);

  // Auto-open the modal the first time this empty result is shown — there's no
  // chart to look at, so lead with how to fix it. Once per backtest id (survives
  // tab switches / re-renders); a fresh re-run that's still empty pops again.
  useEffect(() => {
    if (!backtest?.id) return;
    const key = `emptyFixModalShown:${backtest.id}`;
    try {
      if (!sessionStorage.getItem(key)) {
        setShowModal(true);
        sessionStorage.setItem(key, '1');
        track(Events.EMPTY_BACKTEST_FIX_CLICKED, { backtest_id: backtest.id, auto: true });
      }
    } catch {
      setShowModal(true);
    }
  }, [backtest?.id]);

  const openModal = () => {
    track(Events.EMPTY_BACKTEST_FIX_CLICKED, { backtest_id: backtest.id });
    setShowModal(true);
  };

  return (
    <>
      {showModal && (
        <FixEmptyBacktestModal
          backtest={backtest}
          onEditInQuickEdit={onEditInQuickEdit}
          onRetested={onRetested}
          onRequiresSignup={onRequiresSignup}
          onClose={() => setShowModal(false)}
        />
      )}
      <div style={{
        background: 'linear-gradient(135deg, rgba(217,119,6,0.1), rgba(99,102,241,0.08))',
        border: '1px solid rgba(217,119,6,0.35)',
        borderRadius: 10, padding: '16px 20px', marginBottom: 24,
        display: 'flex', alignItems: 'center', justifyContent: 'space-between',
        gap: 16, flexWrap: 'wrap',
      }}>
        <div style={{ minWidth: 220, flex: 1 }}>
          <div style={{ fontWeight: 700, color: 'var(--text)', marginBottom: 4 }}>
            🤔 This strategy didn’t place any trades
          </div>
          <div style={{ fontSize: 13, color: 'var(--muted)' }}>
            Its entry conditions never triggered over this period, so there’s no return to show.
            Get AI suggestions and tweak it so it actually trades.
          </div>
        </div>
        <Button variant="primary" onClick={openModal} style={{ flexShrink: 0 }}>
          Get it trading →
        </Button>
      </div>
    </>
  );
}
